// /w/:wid/… — keeps the session's world in step with the URL.
import { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { useSession } from "@/state/session";

export function WorldRoute() {
  const { wid: widParam } = useParams();
  const wid = Number(widParam);
  const setWorld = useSession((s) => s.setWorld);
  const current = useSession((s) => s.wid);
  useEffect(() => {
    if (Number.isInteger(wid) && wid > 0 && wid !== current) setWorld(wid);
  }, [wid, current, setWorld]);
  if (!Number.isInteger(wid) || wid <= 0) return <Navigate to="/worlds" replace />;
  return <Outlet />;
}
